@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.engineservice.cr

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.dashboard.ScreenManager
import org.example.project.engineservice.ServiceApi
import org.example.project.service.LizenzService
import org.example.project.service.GlobalManager
import org.example.project.utils.All
import org.jetbrains.compose.web.dom.Div

@Composable
fun CUSCRFlow() {
    val scope = rememberCoroutineScope()
    val crLiveVersion = GlobalManager.jsonDomainVersion("cr")
    var state by remember { mutableStateOf("HUB") }

    var aktiveScreens by remember { mutableStateOf<List<All>>(emptyList()) }
    var ladeModule by remember { mutableStateOf(false) }
    var gewaehlterScreen by remember { mutableStateOf("") }
    var betreff by remember { mutableStateOf("") }
    var beschreibung by remember { mutableStateOf("") }
    var isSending by remember { mutableStateOf(false) }
    var sendError by remember { mutableStateOf("") }
    var eingereicht by remember { mutableStateOf(false) }
    var letzteNummer by remember { mutableStateOf("") }
    var verlaufCrs by remember { mutableStateOf<List<All>>(emptyList()) }

    LaunchedEffect(state) {
        if (state == "AENDERUNG" && aktiveScreens.isEmpty()) {
            ladeModule = true
            aktiveScreens = LizenzService.getEffectiveScreens()
                .asSequence()
                .filter { it.isNotBlank() }
                .distinct()
                .filter { ScreenManager.labelForKey(it).isNotBlank() }
                .map { key -> All(key = key, label = ScreenManager.labelForKey(key)) }
                .sortedBy { it.label.lowercase() }
                .toList()
            ladeModule = false
        }
    }

    LaunchedEffect(state, crLiveVersion) {
        if (state == "LISTE") {
            verlaufCrs = runCatching { ServiceApi.loadCr("company") }.getOrDefault(emptyList())
        }
    }

    fun resetForm() {
        gewaehlterScreen = ""
        betreff = ""
        beschreibung = ""
        sendError = ""
        eingereicht = false
        letzteNummer = ""
    }

    fun absenden() {
        if (isSending) return
        isSending = true
        sendError = ""

        scope.launch {
            val screenLabel = if (state == "AENDERUNG") {
                aktiveScreens.firstOrNull { it.key == gewaehlterScreen }?.label.orEmpty()
            } else {
                ""
            }

            val savedCr = runCatching {
                ServiceApi.createCr(
                    type = if (state == "NEU") "new" else "change",
                    screenKey = gewaehlterScreen,
                    screenLabel = screenLabel,
                    betreff = betreff,
                    beschreibung = beschreibung
                )
            }.getOrNull()

            if (savedCr != null) {
                letzteNummer = savedCr.crNummer.ifBlank { savedCr.id }
                eingereicht = false
                state = "LISTE"
            } else {
                sendError = "CR konnte nicht gespeichert werden."
            }

            isSending = false
        }
    }

    CUSCRFlowLayout(
        state = state,
        eingereicht = eingereicht,
        letzteNummer = letzteNummer,
        onBack = {
            if (state != "HUB" && !eingereicht) {
                state = "HUB"
            }
        },
        onResetToHub = {
            resetForm()
            state = "HUB"
        }
    ) {
        CUSCRHeader(state)
        CUSCRBody(state) {
            when (state) {
                "HUB" -> {
                    CUSCRHub(
                        onNeu = { resetForm(); state = "NEU" },
                        onAenderung = { resetForm(); state = "AENDERUNG" },
                        onListe = { state = "LISTE" }
                    )
                }

                "NEU" -> {
                    CUSCrNeuesModulForm(
                        betreff = betreff,
                        beschreibung = beschreibung,
                        sendError = sendError,
                        isSending = isSending,
                        onBetreffChange = { betreff = it },
                        onBeschreibungChange = { beschreibung = it },
                        onSubmit = ::absenden
                    )
                }

                "AENDERUNG" -> {
                    CUSCrAenderungForm(
                        aktiveScreens = aktiveScreens,
                        ladeModule = ladeModule,
                        gewaehlterScreen = gewaehlterScreen,
                        betreff = betreff,
                        beschreibung = beschreibung,
                        sendError = sendError,
                        isSending = isSending,
                        onScreenChange = { gewaehlterScreen = it },
                        onBetreffChange = { betreff = it },
                        onBeschreibungChange = { beschreibung = it },
                        onSubmit = ::absenden
                    )
                }

                "LISTE" -> {
                    Div({}) {
                        CUSCRBearbeiten(verlaufCrs = verlaufCrs)
                    }
                }
            }
        }
    }
}
